import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import { IxTooltip } from '../src/IxTooltip.js';
import '../src/ix-tooltip.js';

// TODO
describe('A11yTest', () => {
  it('passes the a11y audit', async () => {
    const el = await fixture<IxTooltip>(html` <ix-tooltip></ix-tooltip> `);

    // await expect(el).shadowDom.to.be.accessible();
    await expect(el).shadowDom.not.to.be.accessible();
  });
});
